import { Box } from '@mui/material'

const Texts = {
  ONLY_OTHER_SIGN_REMOVED: (
    <p>
      Внимание! В акте отсутствуют представители в полях: <b>Иные лица</b>. В
      договоре по данным полям назначены представители.
    </p>
  ),
  ONLY_PREP_SIGN_REMOVED: (
    <p>
      Внимание! В акте отсутствуют представители в полях:{' '}
      <b>Авторский надзор</b>. В договоре по данным полям назначены
      представители.
    </p>
  ),
  BOTH_OTHER_AND_PREP_SIGN_REMOVED: (
    <p>
      Внимание! В акте отсутствуют представители в полях: <b>Иные лица</b>,{' '}
      <b>Авторский надзор</b>. В договоре по данным полям назначены
      представители.
    </p>
  ),
  LEGACY_DUPLICATE_ASSIGNEES:
    'Проверьте состав комиссии в акте. В некоторых полях присутствуют дубликаты.',
}

const Icon = () => (
  <svg
    style={{
      flex: '0 0 20px',
      alignSelf: 'flex-start',
    }}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_22179_107436)">
      <path
        d="M17.35 15C18.3499 13 12.0001 3 9.99976 3C7.99938 3 1.6499 13.0004 2.65004 15C3.65018 16.9996 16.3501 17 17.35 15Z"
        stroke="#333333"
        stroke-linecap="round"
      />
      <path
        d="M9.97995 11.3261L9.60012 8C9.60012 8 9.44963 6.5 9.99981 6.5C10.5496 6.5 10.4001 8 10.4001 8L10.0197 11.3261C10.017 11.3498 9.98265 11.3498 9.97995 11.3261Z"
        stroke="#333333"
        stroke-linecap="round"
      />
      <circle cx="10" cy="14" r="1" fill="#333333" />
    </g>
    <defs>
      <clipPath id="clip0_22179_107436">
        <rect width="16" height="16" fill="white" transform="translate(2 2)" />
      </clipPath>
    </defs>
  </svg>
)

export function InspectorsRemovedNotice({
  actBannerTypes,
}: {
  actBannerTypes?: keyof typeof Texts | Array<keyof typeof Texts>
}) {
  const hasLegacyDuplicateAssignees = Array.isArray(actBannerTypes)
    ? actBannerTypes.includes('LEGACY_DUPLICATE_ASSIGNEES')
    : actBannerTypes === 'LEGACY_DUPLICATE_ASSIGNEES'
  const actBannerType = hasLegacyDuplicateAssignees
    ? 'LEGACY_DUPLICATE_ASSIGNEES'
    : Array.isArray(actBannerTypes)
    ? actBannerTypes[0]
    : actBannerTypes

  return (
    actBannerType ? (
      <Box
        sx={{
          backgroundColor: hasLegacyDuplicateAssignees ? '#F8E4E4' : '#F9ECD2',
          padding: '8px 12px',
          borderRadius: '4px',
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
        }}
      >
        <Icon />
        {Texts[actBannerType]}
      </Box>
    ) : null
  )
}
